var exports = {
  "iE": "xaee3c4fa--623620--wrapper",
  "Qq": "xaee3c4fa--623620--text",
  "P7": "xaee3c4fa--623620--inner-wrapper",
  "xA": "xaee3c4fa--623620--footnote",
};

module.exports = exports;
